/**
 * @module app.shared
 */

import { ExpressionCloner, Expression, AccessMember, CallMember, ValueConverter } from 'aurelia-framework';

export class ExpressionRebaser extends ExpressionCloner {

    constructor(public base: Expression) {
        super();
        this.base = base;
    }

    public visitAccessThis(access: any): any {
        if(access.ancestor !== 0) {
            throw new Error('$parent expressions cannot be rebased.');
        }
        return this.base;
    }

    public visitAccessScope(access: any): any {
        if(access.ancestor !== 0) {
            throw new Error('$parent expressions cannot be rebased.');
        }
        return new AccessMember(this.base, access.name);
    }

    public visitCallScope(call: any): any {
        if(call.ancestor !== 0) {
            throw new Error('$parent expressions cannot be rebased.');
        }
        //TODO: For some reason typings don't include cloneExpressionArray method of ExpressionCloner or args on CallMember
        return new CallMember(this.base, call.name, (this as any).cloneExpressionArray((call as any).args));
    }

    public visitValueConverter(converter: ValueConverter): any {
        //TODO: Typings claim accept() returns void
        const rebase: Expression = converter.expression.accept(this) as any;
        return new ValueConverter(rebase, converter.name, ([] as Expression[]).concat(converter.args), [rebase]);
    }

    public visitPrefix(prefix: any): any {
        //TODO: I Don't know what this function is for, but it seems to be required.
        //It was not included in the original example from: https://blog.ashleygrant.com/2017/07/09/getting-my-hands-dirty-with-aurelias-binding-engine/
        //if(prefix.ancestor !== 0) {
        //    throw new Error('$parent expressions cannot be rebased.');
        //}

        // This gets used by a "Unary" type expression, which didnt' exist in the mockup. I feel like this function should return something like:
        // return  new Unary(prefix.operation, prefix.expression.accept(this)
        // However, the type Unary doesn't exist and I can't seem to type it as "any".

        return prefix;
    }
}

export function rebaseExpression(expression: Expression, baseExpression: Expression | string | null): Expression {
    //TODO: Not really sure about string vs. Expression on these
    const visitor = new ExpressionRebaser(baseExpression as Expression);
    //TODO: Typings claim accept() returns void
    return (expression as any).accept(visitor);
}
